
<app-nav></app-nav>
<div class="senior-citizen-quote">
  <div class="row web-view" >
    <div class="breadcumb row"  style="display: flex; justify-content: center;">
      <ul>
        <li>Age</li>
        <li class="active">Quotes</li>
        <!-- <li>Proposal Form</li>
        <li>Payment</li> -->
      </ul>
    </div>
    <div class="row mt-3" style="width: 100%; justify-content: center; color: #F17C5D; font-weight: 600;">Quote for Senior Citizen Health Insurance</div>
    <div class="row mt-3" style="width: 100%;">
      <div class="col-md-2 col-lg-2">
      <div class="senior-citizen additionalCover">
        <div class="cover-header">
          Calculate Premium
        </div>
        <div class="padd">
          <span class="sm-Invoice-Value"> Sum Insured(In Rs. Lakh) </span>
          <select class="form-control sm-Invoice-Value" value="{{sumInsured}}" [(ngModel)]="sumInsured" (change)="seniorCitizenCalcCall()">
            <option value="3 Lakhs">3 Lakhs</option>
            <option value="4 Lakhs">4 Lakhs</option>
            <option value="5 Lakhs">5 Lakhs</option>
            <option value="7.5 Lakhs">7.5 Lakhs</option>
            <option value="10 Lakhs">10 Lakhs</option>
          </select>

          <span class="sm-Invoice-Value mt-3">Family Size</span>
          <select class="form-control sm-Invoice-Value" value="{{familyDef}}" [(ngModel)]="familyDef" (change)="seniorCitizenCalcCall()">
            <option value="Self Only">Self</option>
            <option value="Self and Spouse">Self and Spouse</option>
          </select>
        </div>
      </div>
      </div>
      <div class="col-md-8 col-lg-8">
        <!--Care Card Start-->
        <!-- commenting care quote card 16th june 23 -->
        <!-- <div class="quote-card-expand " style="height:auto;">
          <div class="row">
            <div class="col-md-7 col-lg-7">
             <div class="row">
               <div class="col-md-4">  <img src="https://securenow.in/static/images/Care_logo_DCA.webp"/></div>
               <div class="col-md-4" style="font-size: 11px;">Premium (Excluding Taxes)</div>
               <div class="col-md-4 amount" *ngIf="!specialCarePremiumAmount" style="font-size: 14px;">{{'Option Not Available'}}</div>
               <div class="col-md-4 amount" *ngIf="specialCarePremiumAmount">{{"₹ "+specialCarePremiumAmount}}</div>
             </div>
            </div>
            <div class="col-md-5 col-lg-5">
             <div class="row">
             <div class="col-md-2"></div>
             <div class="col-md-5 col-lg-5"><button class="btn btn-view" (click)="showMoreCareSpecialDetails()">{{careSpecialButtonName}}</button></div>
             <div class="col-md-5 col-lg-5"><button class="btn btn-buy" (click)="redirectToCareProposalForm()">{{"Buy Now"}}</button></div>
           </div> 
           </div>
          </div>
          <div class="row mt-1 policy-details">
            <div class="col-md-12 col-12">
              <div class="row "  *ngFor="let detail of careSpecial; let i = index" >
               <div *ngIf="i<4" class="col-md-6 col-lg-6  side-data">{{detail.name}}</div>
                <div *ngIf="i<4 && detail.value=='Tick'" class="col-md-6 col-lg-6 "><div class="right-icon"></div></div>
                  <div *ngIf="i<4 && detail.value=='Cross'" class="col-md-6 col-lg-6 "><div class="cross-icon"></div></div>
                    <div *ngIf="i<4 && detail.value!='Tick' && detail.value!='Cross'" class="col-md-6 col-lg-6 ">{{detail.value}}</div>
             </div>
             <div class="mt-2" *ngIf="showCareSpecialDetails">
               <div class="row" *ngFor="let detail of careSpecial; let i = index">
                    <div  *ngIf="i>=4 && i<12" class="col-md-6 col-lg-6  side-data">{{detail.name}}</div>
                    <div *ngIf="i>=4 && i<12 && detail.value=='Tick'" class="col-md-6 col-lg-6 "><div class="right-icon"></div></div>
                      <div *ngIf="i>=4 && i<12 && detail.value=='Cross'" class="col-md-6 col-lg-6 "><div class="cross-icon"></div></div>
                        <div *ngIf="i>=4 && i<12 && detail.value!='Tick' && detail.value!='Cross'" class="col-md-6 col-lg-6 ">{{detail.value}}</div>
              </div>
             </div>
             <div class="mt-2" *ngIf="showCareSpecialDetails">
             <div class="row"  *ngFor="let detail of careSpecial; let i = index" >
               <div *ngIf="i>=12" class="col-md-6 col-lg-6 mt-1 side-data">{{detail.name}}</div>
               <div *ngIf="i>=12 && detail.value=='Tick'" class="col-md-6 col-lg-6 "><div class="right-icon"></div></div>
                <div *ngIf="i>=12 && detail.value=='Cross'" class="col-md-6 col-lg-6 "><div class="cross-icon"></div></div>
                  <div *ngIf="i>=12 && detail.value!='Tick' && detail.value!='Cross'" class="col-md-6 col-lg-6 ">{{detail.value}}</div>
             </div>
             </div>
            </div>
          </div>
        </div> -->
        <!---Care Card End--> 


       <!----Star Card Start-->
       <div class="quote-card-expand mt-3" style="height:auto;">
        <div class="row">
          <div class="col-md-7 col-lg-7">
           <div class="row">
             <div class="col-md-4">  <img src="../../assets/images/star.png"/></div>
             <div class="col-md-4" style="font-size: 11px;">Premium (Excluding Taxes)</div>
             <div class="col-md-4 amount" *ngIf="starPremiumAmount">{{"₹ " +starPremiumAmount}}</div>
             <div class="col-md-4 amount" *ngIf="!starPremiumAmount" style="font-size: 14px;">{{'Option Not Available'}}</div>
           </div>
          </div>
          <div class="col-md-5 col-lg-5">
            <div class="row">
           <div class="col-md-2"></div>
           <div class="col-md-5 col-lg-5"><button class="btn btn-view" (click)="showMoreStarDetails()">{{starButtonName}}</button></div>
           <div class="col-md-5 col-lg-5"><button class="btn btn-buy" (click)="redirectToThankYouPage()">{{"Buy Now"}}</button></div>
          </div>          
          </div>
        </div>
        <div class="row mt-2 policy-details">
          <div class="col-md-12 col-12">
            <div class="row "  *ngFor="let detail of starData; let i = index" >
             <div *ngIf="i<4" class="col-md-6 col-lg-6  side-data">{{detail.name}}</div>
             <div *ngIf="i<4 && detail.value=='Tick'" class="col-md-6 col-lg-6 "><div class="right-icon"></div></div>
              <div *ngIf="i<4 && detail.value=='Cross'" class="col-md-6 col-lg-6 "><div class="cross-icon"></div></div>
                <div *ngIf="i<4 && detail.value!='Tick' && detail.value!='Cross'" class="col-md-6 col-lg-6 ">{{detail.value}}</div>
         
           </div>
           <div class="row mt-2" *ngIf="showStarDetails">
             <div class="col-md-6 col-lg-6" *ngFor="let detail of starData; let i = index">
               <div class="row" *ngIf="i>=4 && i<12">
                 <div class="col-md-4 col-lg-4 side-data">{{detail.name}}</div>
                 <div *ngIf="detail.value=='Tick'" class="col-md-6 col-lg-6 "><div class="right-icon"></div></div>
                 <div *ngIf="detail.value=='Cross'" class="col-md-6 col-lg-6 "><div class="cross-icon"></div></div>
                   <div *ngIf="detail.value!='Tick' && detail.value!='Cross'" class="col-md-6 col-lg-6 ">{{detail.value}}</div>
                 </div> 
            </div>
           </div>
           <div class="mt-2" *ngIf="showStarDetails">
           <div class="row"  *ngFor="let detail of starData; let i = index"  >
             <div *ngIf="i>=12" class="col-md-6 col-lg-6 mt-1 side-data">{{detail.name}}</div>
             <div *ngIf="i>=12 && detail.value=='Tick'" class="col-md-6 col-lg-6 "><div class="right-icon"></div></div>
             <div *ngIf="i>=12 && detail.value=='Cross'" class="col-md-6 col-lg-6 "><div class="cross-icon"></div></div>
               <div *ngIf="i>=12 && detail.value!='Tick' && detail.value!='Cross'" class="col-md-6 col-lg-6 ">{{detail.value}}</div>
             </div>
           </div>
          </div>
        </div>
      </div>
       <!--Star Card End-->

         <!---Religare Card Start-->
         <!-- care card removing asked by rakhi 16th june 23 -->
         <!-- <div class="quote-card-expand mt-3" style="height:auto;">
          <div class="row">
            <div class="col-md-7 col-lg-7">
             <div class="row">
               <div class="col-md-4">  <img src="https://securenow.in/static/images/Care_logo_DCA.webp"/></div>
               <div class="col-md-4" style="font-size: 11px;">Premium (Excluding Taxes)</div>
               <div class="col-md-4 amount" *ngIf="!CarePremiumAmount" style="font-size: 14px;">{{'Option Not Available'}}</div>
               <div class="col-md-4 amount" *ngIf="CarePremiumAmount">{{"₹ "+CarePremiumAmount}}</div>
             </div>
            </div>
            <div class="col-md-5 col-lg-5">
             <div class="row">
             <div class="col-md-2"></div>
             <div class="col-md-5 col-lg-5"><button class="btn btn-view" (click)="showMoreCareDetails()">{{careButtonName}}</button></div>
             <div class="col-md-5 col-lg-5"><button class="btn btn-buy" (click)="redirectToThankYouPage()">{{"Buy Now"}}</button></div>
           </div> 
           </div>
          </div>
          <div class="row mt-1 policy-details">
            <div class="col-md-12 col-12">
              <div class="row "  *ngFor="let detail of careData; let i = index" >
               <div *ngIf="i<4" class="col-md-6 col-lg-6  side-data">{{detail.name}}</div>
               <div *ngIf="i<4 && detail.value=='Tick'" class="col-md-6 col-lg-6 "><div class="right-icon"></div></div>
                 <div *ngIf="i<4 && detail.value=='Cross'" class="col-md-6 col-lg-6 "><div class="cross-icon"></div></div>
                   <div *ngIf="i<4 && detail.value!='Tick' && detail.value!='Cross'" class="col-md-6 col-lg-6 ">{{detail.value}}</div>
             </div>
             <div class="row mt-2" *ngIf="showCareDetails">
               <div class="col-md-6 col-lg-6" *ngFor="let detail of careData; let i = index">
                 <div class="row" *ngIf="i>=4 && i<12">
                   <div class="col-md-4 col-lg-4 side-data">{{detail.name}}</div>
                   <div *ngIf="detail.value=='Tick'" class="col-md-6 col-lg-6 "><div class="right-icon"></div></div>
                     <div *ngIf="detail.value=='Cross'" class="col-md-6 col-lg-6 "><div class="cross-icon"></div></div>
                       <div *ngIf="detail.value!='Tick' && detail.value!='Cross'" class="col-md-6 col-lg-6 ">{{detail.value}}</div>
                 </div> 
              </div>
             </div>
             <div class="mt-2" *ngIf="showCareDetails">
             <div class="row"  *ngFor="let detail of careData; let i = index" >
               <div *ngIf="i>=12" class="col-md-6 col-lg-6 mt-1 side-data">{{detail.name}}</div>
               <div *ngIf="i>=12 && detail.value=='Tick'" class="col-md-6 col-lg-6 "><div class="right-icon"></div></div>
                 <div *ngIf="i>=12 && detail.value=='Cross'" class="col-md-6 col-lg-6 "><div class="cross-icon"></div></div>
                   <div *ngIf="i>=12 && detail.value!='Tick' && detail.value!='Cross'" class="col-md-6 col-lg-6 ">{{detail.value}}</div>
                 </div>
             </div>
            </div>
          </div>
        </div> -->
        <!---Religare Card End-->
      </div>
    </div>

    
</div>
   
    

  <div class="row mobile-view" >
    <div class="breadcumb row"  style="display: flex; justify-content: center;">
      <ul>
        <li class="active">Benefits</li>
        <!-- <li>Proposal Form</li>
        <li>Payment</li> -->
      </ul>
    </div>
    <div class="row">
      <div class="col-3"></div>
      <div class="col-9" style="display: flex; justify-content: flex-end;">
        <img class="img-class-fhi" src="https://static-files-website.s3.ap-south-1.amazonaws.com/image_2022_06_28T11_37_27_491Z.png">
      </div>
    </div>
   <div class="container-fluid mt-5" style="width: 90%;margin: 0 auto;">
    <div class="senior-citizen additionalCover">
      <div class="cover-header">
        Calculate Premium
      </div>
      <div class="padd">
        <span class="sm-Invoice-Value"> Sum Insured(In Rs. Lakh) </span>
        <select class="form-control sm-Invoice-Value" value="{{sumInsured}}" [(ngModel)]="sumInsured" (change)="seniorCitizenCalcCall()">
          <option value="3 Lakhs">3 Lakhs</option>
          <option value="4 Lakhs">4 Lakhs</option>
          <option value="5 Lakhs">5 Lakhs</option>
          <option value="7.5 Lakhs">7.5 Lakhs</option>
          <option value="10 Lakhs">10 Lakhs</option>
        </select>

        <span class="sm-Invoice-Value mt-3">Family Size</span>
        <select class="form-control sm-Invoice-Value" value="{{familyDef}}" [(ngModel)]="familyDef" (change)="seniorCitizenCalcCall()">
          <option value="Self Only">Self</option>
          <option value="Self and Spouse">Self and Spouse</option>
        </select>
      </div>
    </div>
   </div>
   <!-- care card starts  -->
   <!-- commenting care quote card 16th june 23 -->
   <!-- <div class="row my-3">
    <div class="quote-card-expand " style="height:auto;width: 78%;margin: 0 auto;">
      <p style="font-size: 12px; font-weight: bold;">Option 1: Care Senior Citizen Health Insurance Plan</p>
      <hr/>
         <div class="row p-1">
           <div class="col-6" >  <img src="https://securenow.in/static/images/Care_logo_DCA.webp"/></div>
           <div class="col-6"> 
            <div class=" amount" *ngIf="!specialCarePremiumAmount" style="font-size: 14px;text-align: right;">{{'Option Not Available'}}</div>
            <div class=" amount" *ngIf="specialCarePremiumAmount" style="text-align: right">{{"₹ "+specialCarePremiumAmount}}</div>
            <div class="mt-2" style="font-size: 9px;text-align: right">Premium </div>
            <div class="" style="font-size: 8px;text-align: right">(Excluding Taxes)</div>
           </div>
          
         </div>
         <hr/>
         <div class="row mt-3 p-1" style="float:right">
          <div class=""></div>
         <div class="mx-3" ><button class="btn btn-view"  (click)="showMoreCareSpecialDetails()">{{careSpecialButtonName}}</button></div>
         <div class=""><button class="btn btn-buy" (click)="redirectToCareProposalForm()">{{"Buy Now"}}</button></div>
       </div> 
      <div class="row mt-1 policy-details" style="clear: both">
        <div class="col-md-12 col-12">
         <div class="mt-2" *ngIf="showCareSpecialDetails">
           <div class="row" *ngFor="let detail of careSpecial; let i = index">
                <div  *ngIf="i>=0 " class="col-6  side-data">{{detail.name}}</div>
                <div *ngIf="i>=0 && detail.value=='Tick'" class="col-6 "><div class="right-icon"></div></div>
                  <div *ngIf="i>=0 && detail.value=='Cross'" class="col-6 "><div class="cross-icon"></div></div>
                    <div *ngIf="i>=0 && detail.value!='Tick' && detail.value!='Cross'" class="col-6 ">{{detail.value}}</div>
          </div>
         </div>
        </div>
      </div>
    </div>
   </div> -->
   <!-- card card ends -->

   
 
    <!-- Star card starts  -->
    <div class="row my-3">
      <div class="quote-card-expand mt-3" style="height:auto;width: 78%;margin: 0 auto;">
      <!-- <p style="font-size: 12px;font-weight: bold;">Option 2: Star Senior Citizens Red Carpet Health Insurance </p> -->
        <hr/>
           <div class="row p-1">
               <div class="col-6">  <img src="../../assets/images/star.png" width="105px"/></div>
             <div class="col-6">
               <div class=" amount" *ngIf="!starPremiumAmount" style="font-size: 14px;text-align: right;">{{'Option Not Available'}}</div>
               <div class="amount" *ngIf="starPremiumAmount" style="text-align: right">{{"₹ " +starPremiumAmount}}</div>
               <div class="mt-2" style="font-size: 9px;text-align: right;">Premium </div>
               <div class="" style="font-size: 9px;text-align: right;">(Excluding Taxes)</div>
             </div>
            
           </div>
           <hr/>
            <div class="row mt-3 p-1" style="float:right">
          <div class=""></div>
           <div class="mx-3"><button class="btn btn-view" (click)="showMoreStarDetails()">{{starButtonName}}</button></div>
           <div class=""><button class="btn btn-buy" (click)="redirectToThankYouPage()">{{"Buy Now"}}</button></div>
          </div>          
        <div class="row mt-2 policy-details" style="clear: both">
          <div class="col-md-12 col-12">
            <div class="mt-2" *ngIf="showStarDetails" style="clear: both">
              <div class="row "  *ngFor="let detail of starData; let i = index" >
                <div *ngIf="i>=0" class="col-6 side-data">{{detail.name}}</div>
                <div *ngIf="i>=0 && detail.value=='Tick'" class="col-6"><div class="right-icon"></div></div>
                 <div *ngIf="i>=0 && detail.value=='Cross'" class="col-6 "><div class="cross-icon"></div></div>
                   <div *ngIf="i>=0 && detail.value!='Tick' && detail.value!='Cross'" class="col-6 ">{{detail.value}}</div>
            
              </div>
            </div>
            
          </div>
        </div>
      </div>
   
      
    </div>
    <!-- Star card ends  -->
    <!-- Religare card starts  -->
    <!-- Care card commenting asked by Rakhi 16th june 23 -->
   <!-- <div class="row my-3">
    <div class="quote-card-expand mt-3" style="height:auto;width: 78%;margin: 0 auto;">
      <p class="fw-bold" style="font-size: 12px;font-weight: bold;">Option 3: Care Senior Citizen Health Insurance Plan </p>
      <hr/>
         <div class="row p-1">
           <div class="col-6">  <img src="https://securenow.in/static/images/Care_logo_DCA.webp"/></div>
           <div class="col-6">
             <div class="col-md-4 amount" *ngIf="!CarePremiumAmount" style="font-size: 14px;text-align: right;">{{'Option Not Available'}}</div>
             <div class="col-md-4 amount" *ngIf="CarePremiumAmount" style="text-align: right">{{"₹ "+CarePremiumAmount}}</div>
             <div class="mt-2" style="font-size: 9px;text-align: right">Premium </div>
             <div class="" style="font-size: 9px;text-align: right;">(Excluding Taxes)</div>
           </div>
         </div>
        <hr/>
         <div class="row mt-1 p-1" style="float: right">
          <div class=""></div>
         <div class="mx-3"><button class="btn btn-view" (click)="showMoreCareDetails()">{{careButtonName}}</button></div>
         <div class=""><button class="btn btn-buy" (click)="redirectToThankYouPage()">{{"Buy Now"}}</button></div>
        </div>
      <div class="row mt-1 policy-details"style="clear: both">
        <div class="col-md-12 col-12" >
          <div class="mt-2"*ngIf="showCareDetails">
            <div class="row "  *ngFor="let detail of careData; let i = index" >
              <div *ngIf="i>=0" class="col-6  side-data">{{detail.name}}</div>
              <div *ngIf="i>=0 && detail.value=='Tick'" class="col-6 "><div class="right-icon"></div></div>
                <div *ngIf="i>=0 && detail.value=='Cross'" class="col-6 "><div class="cross-icon"></div></div>
                  <div *ngIf="i>=0 && detail.value!='Tick' && detail.value!='Cross'" class="col-6 ">{{detail.value}}</div>
            </div>
          </div>
          
        </div>
          
        </div>
   </div>
   </div> -->

   <!-- Religare card ends  -->


</div>